import { useState } from "react";
import primaryComponents from "../../../primaryComponents";
import { useValidation } from "./useValidation";
import { useCreatePharmacyIndication } from "../../../../hooks/api/mutations/useOrder";

export const CreatePharmacyIndication = ({ closeModal = () => {} }) => {
  const [formData, setformData] = useState({
    name: "",
  });

  const { mutate: createIndication, isLoading } = useCreatePharmacyIndication();
  const handleCreateIndication = () => {
    createIndication(formData, {
      onSuccess: () => {
        closeModal();
      },
    });
  };

  const {
    handleSubmit,
    control,
    register,
    trigger,
    formState: { errors },
  } = useValidation({ ...formData });

  return (
    <div>
      <primaryComponents.InputFieldV2
        name="name"
        control={control}
        register={register}
        label={"Indication Name"}
        placeholder="Enter indication name"
        errorMessage={errors.name}
        onKeyUp={() => errors.name !== undefined && trigger("name")}
        onChange={({ target: { value } }) => {
          setformData((prev) => ({ ...prev, name: value }));
        }}
      />
      <primaryComponents.Button
        classNames={"mt-4 btn btn--primary w-100"}
        isLoading={isLoading}
        isDisabled={isLoading}
        loadingText={"Creating..."}
        onClick={handleSubmit(handleCreateIndication)}
      >
        Create Indication
      </primaryComponents.Button>
    </div>
  );
};
